<template>
	<div class="tq-custom-columns" @click="visibleDialog = true" v-show="!hiddenCustomIcon">
		<tq-dialog width="800px" class="custom-column-dialog-wrapper"  v-model="visibleDialog" :header="title" :destroy-on-close="true" :append-to-body="true">
			<div class="tq-custom-columns__height">
				<p class="tq-custom-columns__height-label">行高设置</p>
				<el-radio-group v-model="lineHeight" class="tq-custom-columns__height-radio" size="small">
					<el-radio v-for="item in radioOptions" :key="item.value" :value="item.value">
						<span :class="['inactive', item.value === lineHeight && 'is-active']">{{ item.label }}</span>
					</el-radio>
				</el-radio-group>
			</div>
			<div class="tq-custom-columns__table">
				<el-table
					v-if="isDestroy"
					ref="customTableRef"
					border
					max-height="450px"
					:data="tableData"
					:row-class-name="tableRowClassName"
					@header-dragend="onTableWidthChange"
				>
					<!-- <el-table-column type="selection" width="40" />
					<el-table-column label="Date" width="120">
						<template #default="scope">{{ scope.row.date }}</template>
					</el-table-column> -->
					<el-table-column
						v-for="item of tableColumns"
						:class-name="`${item.prop === 'columnName' && 'no-padding'}`"
						:key="item.prop"
						v-bind="item"
						:align="item.prop !== 'columnName' ? 'center' : 'left'"
					>
						<template v-if="item.prop === 'selection'" #header>
							<el-checkbox v-model="allCheck" @change="onAllCheck"></el-checkbox>
						</template>
						<template v-if="item.prop === 'selection'" #default="{ row }">
							<el-checkbox v-model="row.columnCheck" :disabled="row.columnRequire"></el-checkbox>
						</template>
						<template v-else-if="item.prop === 'columnName'" #default="{ row }">
							<p :class="['tq-custom-columns__table-row', isDraggable(row) && 'disabled']">
								<span>{{ row.columnName }}</span>
								<span
									:class="['tq-custom-columns__table-row-bg', isDraggable(row) && 'disabled']"
									:style="{ width: (row.columnWidth || 0) + 'px' }"
								></span>
							</p>
						</template>
						<template v-else-if="item.prop === 'columnAttr'" #default="{ row }">
							<span>{{ row.columnAttr }}</span>
						</template>
						<template v-else-if="item.prop === 'columnWidth'" #default="{ row }">
							<el-input
								v-model="row.columnWidth"
								@input="onWidthInput(row)"
								@change="onWidthChange(row)"
							></el-input>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<template #footer>
				<div class="tq-custom-columns__footer">
					<div class="tq-custom-columns__footer-left">
						<el-button @click="onResetDefaultOptions">还原默认</el-button>
					</div>
					<div class="tq-custom-columns__footer-right">
						<el-button @click="visibleDialog = false">取消</el-button>
						<el-button type="primary" @click="onSave">保存自定义</el-button>
					</div>
				</div>
			</template>
		</tq-dialog>
	</div>
</template>

<script lang="ts">
// @ts-ignore
import Sortable from "sortablejs"
import { $customSet } from '../../../utils/tools'
import { ElMessage, ElMessageBox } from 'element-plus'
export default {
	name: "TqCustomColumns",
	props: {
		columns: {
			type: Array,
			default: () => [],
		},
		hiddenCustomIcon: {
			type: Boolean,
			default: false,
		},
		originColumns: {
			type: Array,
			default: () => [],
		},
		columnMaxWidth: Number,
		cacheKey: String,
	},
	data():any {
		return {
			title: "自定义表格属性",
			visibleDialog: false,
			lineHeight: "normal",
			isDestroy: true,
			tableData: [],
			tableSort: [],
			tableIds: [],
			cacheData: {},
			cacheLineHeight: {},
			leftFixed: -1,
			rightFixed: 99999,
			isResetColumns: false,
			sortableInstance: null,
			messageInstance: null,
			allCheck: false,
			tabelHeaderStyle: {
				backgroundColor: "#F5F5F5",
			},
			tableOptions: {
				align: "left",
			},
			selectionOption: [
				{ label: "空", value: 0 },
				{ label: "必选", value: 1 },
				{ label: "不可移动", value: 2 },
			],
			radioOptions: [
				{ label: "紧凑(30px)", value: "small" },
				{ label: "标准(40px)", value: "normal" },
				{ label: "宽松(50px)", value: "bigger" },
				{ label: "非常宽松(100px)", value: "large" },
			],
			tableColumns: [
				{
					prop: "selection",
					label: "",
					width: "40px",
				},
				{
					prop: "columnName",
					label: "标题",
					headerAlign: "left",
					width: "500px",
				},
				{
					prop: "columnAttr",
					label: "属性",
				},
				{
					prop: "columnWidth",
					label: "列宽(px)",
				},
			],
		}
	},
	watch: {
		visibleDialog(show) {
			show && this.$nextTick(() => this.initDraggable())
		},
		tableData: {
			handler(data) {
				this.allCheck = data.every((item:any) => item.columnCheck)
			},
			deep: true,
		},
	},
	created() {
		this.initDefaultOptions(this.getStorageData() || this.columns)
	},
	methods: {
		onAllCheck(check:any) {
			this.tableData.forEach((item:any) => $customSet(item, "columnCheck", (item.columnRequire || item.columnHidden) ? true : check))
		},
		getStorageData() {
			const cacheData = window.localStorage.getItem("tnCustomColumns")
			const cacheLineHeight:any = window.localStorage.getItem("tnCustomColumnsLineHeight")
			if (cacheLineHeight) {
				this.cacheLineHeight = JSON.parse(cacheLineHeight)
				this.lineHeight = this.cacheLineHeight[this.cacheKey as number] || "normal"
			}
			if (cacheData) {
				this.cacheData = JSON.parse(cacheData)
				const cacheColumns = this.cacheData[this.cacheKey as number]
				if (cacheColumns) {
					if (this.isDifferent(this.cacheData[this.cacheKey as number])) {
						this.$alert("当前表格字段有更新，与自定义的列排序有冲突，需重置列排序。", "表格字段有更新", {
							confirmButtonText: "我知道了",
							type: "warning",
							callback: () => {
								ElMessage({
									type: "info",
									message: "表格字段排序已重置",
								})
							},
						})
						this.isResetColumns = true
						return this.originColumns
					}
					return cacheColumns
				}
				return this.originColumns
			}
		},
		isDifferent(columns:any) {
			return columns.length !== this.originColumns.length
				? true
				: columns.filter((item:any) => {
						if ("type" in item && item.type === "selection") {
							return !this.originColumns.some((it:any) => "type" in it && it.type === "selection")
						} else {
							return !this.originColumns.some((it:any) => it.prop === item.prop && it.fixed === item.fixed)
						}}).length > 0
		},
		filterAttrs(item:any) {
			if (item.fixed && item.require) {
				return "不可移动/必选"
			} else if (item.fixed) {
				return "不可移动"
			} else if (item.require) {
				return "必选"
			}
			return ""
		},
		tableRowClassName({ row }:any) {
			return row.columnHidden ? "tq-custom-columns__table-hidden" : ""
		},
		initDefaultOptions(columns:any) {
			this.tableData = []
			this.tableSort = []
			columns.forEach((item:any, index:any) => {
				const width = item.width || item.minWidth
				this.tableSort.push(JSON.parse(JSON.stringify(item)))
				this.tableData.push({
					columnHidden: item.type && item.type === "selection",
					columnRequire: !!item.require,
					columnCheck: !item.columnHidden,
					columnName: item.label,
					columnItem: item,
					columnAttr: this.filterAttrs(item),
					columnWidthEdit: false,
					columnWidth: width ? width.replace('px', "") : "",
				})
				if (item.fixed) {
					if (item.fixed === "left" && this.leftFixed < index) {
						this.leftFixed = index
					} else if ((item.fixed === "right" && this.rightFixed < index) || this.rightFixed === 99999) {
						this.rightFixed = index
					}
				}
			})
			if (this.isResetColumns) {
				this.isResetColumns = false
				this.$nextTick(this.onTableDataChange)
			}
		},
		isDraggable(row:any) {
			return row.columnAttr.includes("不可移动")
		},
		initDraggable() {
			this.$nextTick(() => {
				const table = document.querySelector(".tq-custom-columns__table .el-table__body-wrapper tbody")
				if (table) {
					this.sortableInstance = Sortable.create(table, {
						animation: 150,
						dataIdAttr: "data-id",
						handle: ".tq-custom-columns__table-row",
						filter: ".tq-custom-columns__table-row.disabled",
						onEnd: ({ oldIndex, newIndex }:any) => {
							if (newIndex !== oldIndex && newIndex > this.leftFixed && newIndex < this.rightFixed) {
								const isDesc = newIndex < oldIndex
								this.tableSort.splice(newIndex + (isDesc ? 0 : 1), 0, this.tableSort[oldIndex])
								this.tableSort.splice(oldIndex + (isDesc ? 1 : 0), 1)
								this.tableIds = this.sortableInstance.toArray()
							} else {
								this.sortableInstance.sort(this.tableIds, true)
							}
						},
					})
					setTimeout(() => {
						this.tableIds = this.sortableInstance.toArray()
					}, 300)
				}
			})
		},
		onWidthInput(row:any) {
			row.columnWidth = row.columnWidth.replace(/\D/g, "")
		},
		onWidthChange(row:any) {
			const num = row.columnWidth
			if (num < 60 || num > this.columnMaxWidth) {
				this.messageInstance = ElMessage.warning({
					message: `列宽数值最小宽度为60px，最大宽度为${this.columnMaxWidth}px`,
					onClose: () => {
						this.messageInstance = null
					},
				})
				row.columnWidth = (row.columnItem.width || row.columnItem.minWidth).replace(/\D/g, "")
			} else {
				row.columnWidthEdit = true
			}
		},
		onTableHeaderChange(newWidth:any, column:any) {
			const targetColumn:any = this.tableData.find((item:any) => item.columnItem.prop === column.property)
			if (targetColumn && Number(targetColumn.columnWidth) !== newWidth) {
				$customSet(targetColumn, "columnWidth", newWidth)
				$customSet(targetColumn, "columnWidthEdit", true)
				this.onTableDataChange(false)
			}
		},
		onTableDataChange(isEmit = true) {
			this.tableSort.forEach((item:any) => {
				if (item.prop) {
					const dataItem:any = this.tableData.find(({ columnItem }:any) => item.prop === columnItem.prop)
					$customSet(item, "columnHidden", !dataItem.columnCheck)
					if (dataItem.columnWidthEdit) {
						const minWidth = dataItem.columnItem.minWidth
						const width = dataItem.columnItem.width
						if (
							(minWidth && Number(minWidth.replace(/\D/g, "")) !== Number(item.columnWidth)) ||
							(width && Number(width.replace(/\D/g, "")) !== Number(item.columnWidth))
						) {
							$customSet(item, "width", dataItem.columnWidth + "px")
						}
					}
				}
			})

			this.cacheData[this.cacheKey] = this.tableSort
			this.cacheLineHeight[this.cacheKey] = this.lineHeight
			window.localStorage.setItem("tnCustomColumns", JSON.stringify(this.cacheData))
			window.localStorage.setItem("tnCustomColumnsLineHeight", JSON.stringify(this.cacheLineHeight))
			if (isEmit) {
				this.$emit("columnsUpdate", { columns: this.tableSort, lineHeight: this.lineHeight })
				// this.$destroy()
			}
		},
		onSave() {
			if (this.messageInstance) {
				return (this.messageInstance = null)
			}
			ElMessageBox.confirm("确认保存自定义表格属性", "保持自定义", {
				type: "warning",
				confirmButtonText: "确认",
				cancelButtonText: "取消",
			})
				.then(() => {
					this.visibleDialog = false
					this.onTableDataChange()
					ElMessage.success("自定义表格属性保存成功")
				})
				.catch(() => {
					// cancel
				})
		},
		onResetDefaultOptions() {
			ElMessageBox.confirm("还原自定义表格属性为默认值？", "还原默认", {
				type: "warning",
				confirmButtonText: "还原",
				cancelButtonText: "取消",
			})
				.then(() => {
					this.visibleDialog = false
					this.lineHeight = "normal"
					ElMessage.success("已还原默认值")
					this.initDefaultOptions(this.originColumns)
					this.onTableDataChange()
				})
				.catch(() => {
					// 取消
				})
		},
		onTableWidthChange(_newWidth:any, oldWidth:any, column:any) {
			column.width = oldWidth
		},
	},
}
</script>
<style>
.custom-column-dialog-wrapper .tq-dialog-wrapper .el-dialog__body {
	padding: 0 20px 16px;
}
</style>
<style>
.tq-custom-columns {
	position: relative;
	top: 3px;
	display: inline-block;
	width: 16px;
	height: 16px;
	margin-left: 5px;
	background: rgba(0, 0, 0, 0) url("./images/icon_set.svg") no-repeat center center;
	cursor: pointer;
}
.tq-custom-columns__height {
	display: flex;
	align-items: center;
	height: 40px;
	width: 100%;
}
.tq-custom-columns__height-label {
	margin: 0 20px 0 0;
	font-family: PingFangSC-Semibold;
	font-size: 14px;
	color: #323232;
	letter-spacing: 0;
	line-height: 14px;
	font-weight: 600;
}
.tq-custom-columns__height-radio .inactive {
	font-family: PingFangSC-Regular;
	font-size: 12px;
	color: rgba(0, 0, 0, 0.8);
	letter-spacing: 0;
	text-align: justify;
	line-height: 12px;
	font-weight: 400;
}
.tq-custom-columns__height-radio .inactive.is-active {
	font-family: PingFangSC-Semibold;
	font-weight: 600;
}
.tq-custom-columns__height-radio .el-radio__input .el-radio__inner {
	width: 16px;
	height: 16px;
}
.tq-custom-columns__height-radio .el-radio__input.is-checked .el-radio__inner::after {
	width: 7px;
	height: 7px;
	background-color: rgba(0, 0, 0, 0);
	border: 2px solid #fff;
}
.tq-custom-columns__table .el-table .el-table__header .el-table__cell {
	height: 30px;
	padding: 0;
	color: #313131;
	background-color: #f5f5f5;
}
.tq-custom-columns__table .el-table .el-table__body .el-table__row .el-table__cell {
	height: 40px;
	padding: 0;
}
.tq-custom-columns__table .el-table .el-table__body .el-table__row .el-table__cell.no-padding .cell {
	padding: 0;
	justify-content: flex-start;
}
.tq-custom-columns__table .el-table .el-table__body .el-table__row .el-table__cell .cell {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
}
.tq-custom-columns__table .tq-custom-columns__table-hidden {
	display: none;
}
.tq-custom-columns__table-row {
	position: relative;
	display: flex;
	align-items: center;
	height: inherit;
	width: 100%;
	margin: 0;
	padding: 0 10px;
}
.tq-custom-columns__table-row-bg {
	display: block;
	position: absolute;
	height: 100%;
	left: 0;
	top: 0;
	background-color: rgba(163, 198, 255, 0.2);
	transition: all 0.3s;
}
.tq-custom-columns__table-row-bg.disabled {
	background-color: rgba(0, 0, 0, 0.04);
}
.tq-custom-columns__footer {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
</style>